<div class="accounts-container">
    <!-- Loader Section -->
    <div *ngIf="isLoading"
        class="ltms-loading d-flex justify-content-center align-items-center position-fixed w-100 h-100"
        style="background-color: rgba(255, 255, 255, 0.5); z-index: 1000;">
        <app-ltms-loader></app-ltms-loader>
    </div>

    <!-- Account List Section -->
    <div class="account-list-container" *ngIf="!isLoading">
        <div class="filter">
            <app-score-search-bar [config]="{width: 275, 'placeholder': 'Search'}"
                (onSearch)="searchData($event)"></app-score-search-bar>
            <div class="sortby-filter">
                <span>{{"SORT_BY" | translate}}</span>
                <app-score-dropdown-menu [config]="{width: '186px'}" [selectedOption]="selectedOption"
                    [options]="options" (selectedOptionChange)="setCurrentSelection($event)"></app-score-dropdown-menu>
            </div>
        </div>
        <div class="card-container">
            <div *ngIf="!isSearchPerformed && showCreateAccountButton" class="card create-account-card">
                <span class="create-account-text">CREATE NEW ACCOUNT</span>
                <span class="plus-sign"><img src="assets/images/plus.svg" /></span>
            </div>
            <!-- "No Accounts Found" Message -->
            <div *ngIf="showNoAccountsMessage" class="no-accounts-container"
                [ngClass]="{'show': showNoAccountsMessage}">
                <span class="no-accounts-text">No accounts found. Please try searching again with a different
                    input.</span>
            </div>

            <div class="card" *ngFor="let accounts of accountsData" (click)="navigateTo('details', accounts._id)">
                <div class="project-redirect">
                    <span class="project-redirect-text" placement="bottom-left" ngbTooltip="{{accounts.display_name || accounts.name}}"
                        tooltipClass="custom-tooltip-background" container="body">{{accounts.display_name || accounts.name}}</span>
                    <span class="project-redirect-image">
                        <img src="assets/images/launch.svg" class="launch-icon" alt="Launch Icon">
                        <img class="me-2 active-icon" src="assets/images/blue-link-icon.svg"
                            alt="Open project icon (active)">
                    </span>
                </div>
                <div class="account-label-holder">
                    <div class="account-label">
                        <span class="label-text">{{"SETUP" | translate}}</span>
                        <span>{{accounts.setup_projects}}</span>
                    </div>
                    <div class="account-label">
                        <span class="label-text">{{"LIVE" | translate}}</span>
                        <span>{{accounts.live_projects}}</span>
                    </div>
                    <div class="account-label">
                        <span class="label-text">{{"On Hold" | translate}}</span>
                        <span>{{accounts.on_hold_projects}}</span>
                    </div>
                    <div class="account-label">
                        <span class="label-text">{{"CLOSED" | translate}}</span>
                        <span>{{accounts.closed_projects}}</span>
                    </div>
                    <div class="account-label">
                        <span class="label-text">{{"ARCHIVED" | translate}}</span>
                        <span>{{accounts.archive_projects}}</span>
                    </div>
                    <div class="account-label">
                        <span class="label-text-total">{{"TOTAL_PROJECTS" | translate}}</span>
                        <span class="total-projects">{{ getTotalProjectsForAccount(accounts) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>